import React, { useRef } from "react";

import ChatInput from '../../components/Chatbot/ChatInput';

export default function ChatbotSection({ name, title, description, topics, userType, className = '' }) {
    const chatRef = useRef();

    const handleTopicClick = (topic) => {
        if (chatRef.current?.sendMessage) {
            chatRef.current.sendMessage(topic);
        }
    };

    return (
        <section className={`bg-purple ${className}`}>
            <div className='container py-8 lg:py-12'>
            <div className="grid grid-cols-12 gap-8">
                <div className="col-span-12 lg:col-span-3 text-right lg:order-2">
                    <div className="relative">
                        <img src='/assets/chatbot.png' />
                        <div className="chat-bubble absolute bottom-0 left-0">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </div>
                    </div>
                    <h3 className="mt-6 text-white">Chat to {name}</h3>
                </div>
                <div className="col-span-12 lg:col-span-9">
                    <h2 className='text-white mb-8'>
                        {title}
                    </h2>
                    <p className="text-white text-lg mb-8">
                        {description}
                    </p>
                    {topics && (
                        <div className="mb-8 flex flex-wrap gap-2">
                            {topics.map((topic, index) => (
                                <button key={index} className="btn btn-white text-white w-full lg:w-auto"
                                    onClick={() => handleTopicClick(topic)}
                                >{topic}</button>
                            ))}
                        </div>
                    )}
                    <div className="bg-white rounded-xl p-5">
                        <ChatInput ref={chatRef} userType={userType} />
                    </div>
                </div>
            </div>
        </div>
        </section>
    );
}
